/**
 * Полоска «📌 Сегодня» — `div.deadline-bar.today-strip#todayStrip`
 * (ui-blocks.md §7.1). Считается по открытым делам исполнителя,
 * бэкенд отдаёт её только роли `executor`. Не кликабельна,
 * пустого состояния нет — при нулях зелёные формулировки.
 */

import type { TodayStripDto } from './types';

interface Props {
    strip: TodayStripDto;
}

export function TodayStrip({ strip }: Props) {
    return (
        <div className="deadline-bar today-strip" id="todayStrip">
            <span className="bar-label">📌 Сегодня</span>
            <span className="bar-stats">
                уходит ответов: <b>{strip.today}</b> · до конца недели: <b>{strip.week}</b> ·{' '}
                {strip.late > 0 ? (
                    <span className="ts-red">просрочено: {strip.late}</span>
                ) : (
                    <span className="ts-green">просрочек нет</span>
                )}
                {' · '}
                {strip.extended > 0 ? (
                    <span className="ts-orange">продлено: {strip.extended}</span>
                ) : (
                    'продлений нет'
                )}
            </span>
        </div>
    );
}
